import { IStore } from "../store";

export const intermediarioSelector = (state: IStore) => state.intermediario;
export const intermediarioDataSelector = (state: IStore) => state.intermediario.data;
